import { Link } from "react-router-dom";

export const Footer = () => {
  return (
    <footer className="bg-[#09090B] text-white mt-24">
      <div className="mx-auto max-w-7xl px-6 md:px-12 py-20">
        <div className="grid md:grid-cols-3 gap-12">
          <div>
            <div className="font-display font-black text-3xl tracking-tighter uppercase mb-4">
              Curated<span className="text-[#FF2A00]">.</span>
            </div>
            <p className="text-zinc-400 text-sm max-w-xs leading-relaxed">
              A hand-picked edit of the best products on Amazon, across every category you love.
            </p>
          </div>
          <div>
            <div className="text-xs tracking-[0.2em] uppercase font-bold text-zinc-500 mb-5">Categories</div>
            <div className="grid grid-cols-2 gap-2">
              {["toys", "gadgets", "beauty", "pets", "fitness", "garden"].map((c) => (
                <Link key={c} to={`/category/${c}`} className="text-sm text-zinc-300 hover:text-[#FF2A00] capitalize transition-colors">
                  {c}
                </Link>
              ))}
            </div>
          </div>
          <div>
            <div className="text-xs tracking-[0.2em] uppercase font-bold text-zinc-500 mb-5">Disclosure</div>
            <p className="text-zinc-400 text-sm leading-relaxed">
              As an Amazon Associate we earn from qualifying purchases. Prices and availability are accurate as of the date shown and may change.
            </p>
          </div>
        </div>
        <div className="border-t border-zinc-800 mt-16 pt-8 flex flex-col md:flex-row justify-between gap-4 text-xs text-zinc-500">
          <span>© {new Date().getFullYear()} Curated. All rights reserved.</span>
          <Link to="/admin/login" data-testid="footer-admin-link" className="hover:text-white transition-colors">Admin</Link>
        </div>
      </div>
    </footer>
  );
};
